import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LegalAcceptanceAdminRecord, LegalAuditFilters, LegalAuditStats } from 'shared';

/**
 * Admin/audit view over the legal acceptance history.
 *
 * Read-only: LegalAcceptance rejects every write server-side, so there is no update
 * or delete counterpart here by construction rather than by omission.
 */
@Injectable({ providedIn: 'root' })
export class LegalAuditService {
  private http = inject(HttpClient);

  getAcceptances(filters: LegalAuditFilters = {}): Observable<{
    acceptances: LegalAcceptanceAdminRecord[];
    pagination: { page: number; per_page: number; total: number; total_pages: number };
  }> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return this.http.get<{
      acceptances: LegalAcceptanceAdminRecord[];
      pagination: { page: number; per_page: number; total: number; total_pages: number };
    }>('/admin/legal/acceptances', { params });
  }

  getAcceptance(id: number): Observable<{ acceptance: LegalAcceptanceAdminRecord }> {
    return this.http.get<{ acceptance: LegalAcceptanceAdminRecord }>(`/admin/legal/acceptances/${id}`);
  }

  getStats(): Observable<LegalAuditStats> {
    return this.http.get<LegalAuditStats>('/admin/legal/stats');
  }
}
